import fetchExpresso from 'utility/fetchExpresso';

import type { ReportSection } from '../mock/reports';

export type ReportLibraryResponse = {
    defaultReportId: string;
    sections: ReportSection[];
};

export async function fetchReportLibrary(eventId: number): Promise<ReportLibraryResponse> {
    const res = await fetchExpresso(`/apiv2/events/${eventId}/reports`);

    if (!res.ok) {
        throw new Error('Failed to load report library');
    }

    return (await res.json()) as ReportLibraryResponse;
}
